import {call, put} from 'redux-saga/effects';
import {receiveCustomerTestimonialsData} from "../actions/customerTestimonialsActions";
import {fetchCustomerTestimonialsData} from "../api/fetchCustomerTestimonialsData";

export default function* getCustomerTestimonialsData(action) {
  try {
    const customerTestimonialsData = yield call(fetchCustomerTestimonialsData);
    yield put(receiveCustomerTestimonialsData(customerTestimonialsData));
  } catch (e) {
    console.log(e)
  }
}



// WEBPACK FOOTER //
// ./src/sagas/customerTestimonialsSaga.js